<template>
  <div class="assistant-nav">
    Assistent
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'AssistantNav',
  };
</script>
